import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmedValidator } from '../../confirmed.validator';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-aggiungi-persona',
  templateUrl: './aggiungi-persona.component.html',
  styleUrls: ['./aggiungi-persona.component.css']
})
export class AggiungiPersonaComponent implements OnInit {
  frmInserimento!: FormGroup;
  lstRuolo: any;
  lstSettoreScientifico: any;
  idutente: any;
  objdettaglio: any

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<AggiungiPersonaComponent>, private snackBar: MatSnackBar,
    private srvUtilita: UtilitaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {


    //console.log(this.data.idRichiesta);
    this.frmInserimento = this.fb.group({ //nuovo profilo //tab1
      idUtentiProfilo: [null],
      Cognome: [null],
      Nome: [null],
      Email: [null, [Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}')]],
      idRuolo: [null],
      idReferenteTipologia: [-1],
      idSettoreScientifico: [null],
      Fascia: ['-'],
      CodiceFiscale: [null, [Validators.pattern('^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$')]],
    })

    if (this.data.idRichiesta) { }

    // console.log('row', this.data.row)
    // console.log('row idRichiestaIscrizioneNominativo', this.data.row.idRichiestaIscrizioneNominativo)
    if (this.data.idRichiestaIscrizioneNominativo > 0) {
      this.getDettaglio();
    } else {

    }


    this.getListaRuolo();
    this.getListaSettoreScientifico();
  }
  /*
  getListaRuolo() {
    this.srvUtilita.getLista('Utenti/GetUtentiProfiloRuoloLista').subscribe((res: any) => {
      this.lstRuolo = res
      //   console.log('res', res)
    })
  }*/
  getListaRuolo() {
    this.srvUtilita.getLista('Utenti/GetRuoliStrutturatoLista').subscribe((res: any) => {
      this.lstRuolo = res
      //  console.log("this.lstRuolo:", this.lstRuolo);
    }, (err: any) => {
    })
  }

  getListaSettoreScientifico() {
    this.srvUtilita.getLista('Utenti/GetSettoreScientificoLista?iVisibile=1').subscribe((res: any) => {
      this.lstSettoreScientifico = res;
      // console.log('res', res)
    })
  }

  getDettaglio() {
    this.srvUtilita.getObj('Utenti/GetRichiesteIscrizioneNominativi?idRichiestaIscrizioneNominativo=' + this.data.idRichiestaIscrizioneNominativo).subscribe((res: any) => {
      this.objdettaglio = res;
      //  console.log('res', res)
      this.frmInserimento.patchValue(this.objdettaglio)
    })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnAnnulla(): void {
    this.showMessage('Operazione annullata.', 'OK')
    this.dialogRef.close()
  }

  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value
    this.idutente = JSON.parse(localStorage.getItem('username') || '0').idUtente;
    const obj = {
      idRichiestaIscrizioneNominativo: -1,
      idRichiestaIscrizione: this.data.idRichiesta,
      Nome: objInserimento.Nome,
      Cognome: objInserimento.Cognome,
      Email: objInserimento.Email,
      idRuolo: objInserimento.idRuolo,
      Fascia: objInserimento.Fascia,
      idSettoreScientifico: objInserimento.idSettoreScientifico,
      CodiceFiscale: objInserimento.CodiceFiscale,
      idUtenteRichiedente: this.idutente
    }

    const objmodifica = {
      idRichiestaIscrizioneNominativo: this.data.idRichiestaIscrizioneNominativo,
      idRichiestaIscrizione: this.data.idRichiesta,
      Nome: objInserimento.Nome,
      Cognome: objInserimento.Cognome,
      Email: objInserimento.Email,
      idRuolo: objInserimento.idRuolo,
      Fascia: objInserimento.Fascia,
      idSettoreScientifico: objInserimento.idSettoreScientifico,
      CodiceFiscale: objInserimento.CodiceFiscale,
      idUtenteRichiedente: this.idutente
    }



    this.srvUtilita.getObj('Utenti/VerificaEmailCodiceFiscale?sEmail=' + objInserimento.Email + '&sCodiceFiscale=' + objInserimento.CodiceFiscale).subscribe((res: any) => {
      if (res == 1) {

        if (objInserimento.idRichiestaIscrizioneNominativo == -1) {
          this.srvUtilita.postObj('Utenti/PostRichiesteIscrizioneNominativi', obj).subscribe((res: any) => {
            this.showMessage('Operazione avvenuta correttamente.', 'OK')
            this.dialogRef.close()

          }, (err: any) => {
            this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
            //  console.log(err.error.Message, 'ERRORE');
          })
        }
        else {
          this.srvUtilita.postObj('Utenti/PostRichiesteIscrizioneNominativi', objmodifica).subscribe((res: any) => {
            this.showMessage('Operazione avvenuta correttamente.', 'OK')
            this.dialogRef.close()

          }, (err: any) => {
            this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
            // console.log(err.error.Message, 'ERRORE');
          })
        }

      }
      if (res == 2) {
        this.showMessage('Errore: Codice FISCALE e EMAIL già presente ', 'OK')
      }
      if (res == 3) {
        this.showMessage('Errore: EMAIL già presente ', 'OK')
      }
      if (res == 4) {
        this.showMessage('Errore: Codice FISCALE già presente ', 'OK')
      }
    }, (err: any) => {
      this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
      // console.log(err.error.Message, 'ERRORE');
    })



    /*
    this.srvUtilita.postObj('Utenti/PostRichiesteIscrizioneNominativi', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })*/
  }







  btnSalvaEmail() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value
    

    const objmodifica = {
      idRichiestaIscrizioneNominativo: this.data.idRichiestaIscrizioneNominativo,
      idRichiestaIscrizione: this.data.idRichiesta,
      Nome: objInserimento.Nome,
      Cognome: objInserimento.Cognome,
      Email: objInserimento.Email,
      idRuolo: objInserimento.idRuolo,
      Fascia: objInserimento.Fascia,
      idSettoreScientifico: objInserimento.idSettoreScientifico,
      CodiceFiscale: objInserimento.CodiceFiscale,
      idUtenteRichiedente: this.idutente
    }


    //SetEmailNominativo(string sEmail, int iIdRichiestaIscrizioneNominativo )
    this.srvUtilita.getObj('Utenti/SetEmailNominativo?sEmail=' + objInserimento.Email
      + '&idRuolo=' + objInserimento.idRuolo+ '&iIdRichiestaIscrizioneNominativo=' + this.data.idRichiestaIscrizioneNominativo ).subscribe((res: any) => {
       
            this.showMessage('Modifica Email - Avvenuta correttamente', 'OK')
        // console.log(err.error.Message, 'ERRORE');
        this.dialogRef.close();
          } 
       
     , (err: any) => {
       this.showMessage('Errore: email già presente', 'OK')
       this.dialogRef.close();
      // console.log(err.error.Message, 'ERRORE');
    })



    /*
    this.srvUtilita.postObj('Utenti/PostRichiesteIscrizioneNominativi', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })*/
  }


}




